import axios, { isAxiosError } from "axios";

// RaiCore, the Go API (Swagger at <url>/swagger/index.html). Sessions are
// http-only cookies, so every request carries credentials and no token is
// ever kept in JavaScript.
export const raiCoreClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_RAICORE_URL,
  timeout: 15_000,
  withCredentials: true,
  headers: { Accept: "application/json" },
});

/** RaiCore's error body (`errs.Error`). */
export interface RaiCoreErrorBody {
  error?: string;
  fields?: Record<string, string>;
}

export class RaiCoreError extends Error {
  constructor(message: string, readonly status: number | null, readonly fields: Record<string, string> = {}) {
    super(message);
    this.name = "RaiCoreError";
  }
}

/** Normalises axios failures; `status` is null when the API couldn't be reached. */
export function toRaiCoreError(error: unknown): RaiCoreError {
  if (error instanceof RaiCoreError) return error;
  if (isAxiosError<RaiCoreErrorBody>(error)) {
    const status = error.response?.status ?? null;
    return new RaiCoreError(error.response?.data?.error ?? error.message, status, error.response?.data?.fields ?? {});
  }
  return new RaiCoreError(error instanceof Error ? error.message : "Unknown error", null);
}
